import { supabase } from "@/integrations/supabase/client";
import type { BillSplit, BillSplitParticipant, ParticipantInput } from "./types";

export async function listMyBillSplits(): Promise<BillSplit[]> {
  const { data, error } = await supabase
    .from("bill_splits")
    .select("*")
    .order("created_at", { ascending: false });
  if (error) throw error;
  return (data ?? []) as BillSplit[];
}

export async function listSplitParticipants(splitId: string): Promise<BillSplitParticipant[]> {
  const { data, error } = await supabase
    .from("bill_split_participants")
    .select("*")
    .eq("split_id", splitId);
  if (error) throw error;
  return (data ?? []) as BillSplitParticipant[];
}

export async function createBillSplit(args: {
  title: string;
  total_cents: number;
  participants: ParticipantInput[];
  notes?: string;
}): Promise<string> {
  const { data, error } = await supabase.rpc("bill_split_create", {
    _title: args.title,
    _total_cents: args.total_cents,
    _participants: args.participants as unknown as never,
    _notes: args.notes ?? null,
  });
  if (error) throw error;
  return data as string;
}

export async function markSharePaid(splitId: string, userId?: string): Promise<void> {
  const { error } = await supabase.rpc("bill_split_mark_paid", {
    _split_id: splitId,
    _user_id: userId ?? null,
  });
  if (error) throw error;
}

export async function declineShare(participantId: string): Promise<void> {
  const { error } = await supabase
    .from("bill_split_participants")
    .update({ status: "declined" })
    .eq("id", participantId);
  if (error) throw error;
}

export async function cancelSplit(splitId: string): Promise<void> {
  const { error } = await supabase
    .from("bill_splits")
    .update({ status: "cancelled" })
    .eq("id", splitId);
  if (error) throw error;
}
